/* eslint-disable @typescript-eslint/restrict-plus-operands */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import {
    Heading4,
    Heading3,
    DoconCard,
    DoconTabs,
    DoconInput,
    Icons,
    FlexBox,
    BaseBox,
} from '@docon/docon-ui-library';
import queryString from 'query-string';
import { Image, Loader } from 'shared';
import { isEmpty } from 'lodash-es';
import Layout from 'components/Layout';
import { borderColor, colors } from 'utilities/colorConfig';
import LabCart from './LabCart';
import { getDiscountBanner, getCartItems } from 'redux/reducer/prescription';
import { getEnabledFeatures } from 'redux/reducer/app';
import { CrossIcon } from '@docon/docon-ui-library/lib/V2/shared/icons';
import MedicineCart from './MedicineCart';
import moment from 'moment';
import { rxService } from 'services';

const CardBox = styled(FlexBox)`
  border: 1px solid ${borderColor}; 
  border-radius: 8px;  
  padding: 6px;
  margin-bottom: 5px;
  ${Image}{
    margin-right: 5px;
  }
`;

const Card = styled(DoconCard)`
  padding: 15px;
  margin-bottom: 15px; 
  margin-top: 15px; 

  .templateSearchInputClass{
    width: 80%;
    margin-bottom: 10px;
  }

  ${Heading3} {
    font-weight: bold;
  }

  ${CrossIcon}{
    cursor: pointer;
    margin-top: 18px;
  }
`;

const TextCenter = styled(Heading4)`
  font-weight: 600;
  text-align: center; 
`;

const SearchBox = styled(FlexBox)`
  justify-content: space-between;
`;

const InfoItems = styled(FlexBox)`
  padding: 10px 0 10px;
  justify-content: space-around;
`;

const Tabs = [
    { title: 'LAB TESTS', value: 'LAB TESTS' },
    { title: 'MEDICINES', value: 'MEDICINES' },
];

function CartComponent() {
    const { visitID } = queryString.parse(location.search) || '-';
    const { patientID } = queryString.parse(location.search) || '-';
    const { utm_source } = queryString.parse(location.search) || '-';
    const { doctorID } = queryString.parse(location.search) || '-';
    const [selectedTab, setSelectedTab] = useState('LAB TESTS');
    const [searchInput, setSearchInput] = useState<string>('');
    const [pincodeChanged, setPincodeChanged] = useState<string>('');
    const [tabChange, setTabChange] = useState(false);
    const [pincodeReceived, setPincodeReceived] = useState(false);
    const [maxSearchInput, setMaxSearchInput] = useState(false);
    const [pincodeUpdated, setPincodeUpdated] = useState(false);
    const [showError, setShowError] = useState(false);
    const [state, setState] = useState<any>({});
    const dispatch = useDispatch();
    const { user } = useSelector(state => state.auth);
    const { feature } = useSelector(state => state.app);
    const { bannerByType, cartItems } = useSelector(state => state.prescription);
    const {
        showMedicinesBanner,
        showDiagnosticsBanner,
        cartLabWebBanner,
        cartMedicineWebBanner,
        diagnosticsCount,
        medicinesCount,
    }: any = { ...feature, ...bannerByType };
    const cartLabImg = '/images/cartLab.png';
    const cartMedicineImg = '/images/cartMedicine.png';

    function getPincode(position) {
        fetch('https://maps.googleapis.com/maps/api/geocode/json?address=' + position?.coords?.latitude + ',' + position?.coords?.longitude + '&key=' + 'AIzaSyBuACA0cLDoN_Ae0BoVyW_Gxq0kkl7kXI8')
            .then((response) => response.json())
            .then((responseJson) => {
                const address = responseJson.results[0]?.address_components;
                const pincode = address[address.findIndex(elem => elem['types'].includes('postal_code'))].long_name;
                if (pincode) {
                    setSearchInput(pincode);
                    setMaxSearchInput(pincode.length === 6);
                    setPincodeChanged(pincode);
                }
            });
        setPincodeReceived(false);
    }

    useEffect(() => {
        if (isEmpty(bannerByType)) {
            dispatch(getDiscountBanner({}));
        }
    }, []);

    useEffect(() => {
        setPincodeReceived(true);
        navigator.geolocation.getCurrentPosition(getPincode);
        setPincodeReceived(false);
    }, []);

    useEffect(() => {
        if (isEmpty(feature)) {
            dispatch(getEnabledFeatures({ docID: doctorID, params: { visitIds: [visitID] } }));
        }
        else {
            updateState();
        }
    }, [feature]);

    async function checkVisitID(body: any) {
        try {
            const res = await rxService.checkVisitID(visitID);
            if (res) {
                dispatch(getCartItems(body));
                setPincodeChanged(searchInput);
                setTabChange(false);
            }
        }
        catch (err) {
            console.log(err);
            setShowError(true);
        }
    }

    useEffect(() => {
        if (searchInput.length === 6) {
            setMaxSearchInput(true);
            const body = {
                'visitID': visitID,
                'userID': user.userID,
                'origin': 'patient',
                'platform': 'web',
                'pincode': searchInput,
            };
            if (utm_source === 'sms' || utm_source === 'whatsapp') {
                checkVisitID(body);
            }
            else {
                dispatch(getCartItems(body));
                setPincodeChanged(searchInput);
                setTabChange(false);
            }
        }
    }, [searchInput]);

    function updateState() {
        const newState: any = {};
        const isMedicinePresentNOrdering = utm_source === 'prescription' ? (showMedicinesBanner === 'whitelisted' || showMedicinesBanner === 'notPitched') && medicinesCount > 0 && cartMedicineWebBanner !== undefined : showMedicinesBanner === 'whitelisted' && medicinesCount > 0 && cartMedicineWebBanner !== undefined;
        const isDiagnosticPresentNOrdering = utm_source === 'prescription' ? (showDiagnosticsBanner === 'whitelisted' || showDiagnosticsBanner === 'notPitched') && diagnosticsCount > 0 && cartLabWebBanner !== undefined : showDiagnosticsBanner === 'whitelisted' && diagnosticsCount > 0 && cartLabWebBanner !== undefined;
        const showOfferCard = isMedicinePresentNOrdering || isDiagnosticPresentNOrdering;
        const isComboCard = isMedicinePresentNOrdering && isDiagnosticPresentNOrdering;
        switch (true) {
            case isMedicinePresentNOrdering: {
                newState.title = cartMedicineWebBanner?.title;
                newState.subTitle = cartMedicineWebBanner?.subTitle;
                newState.discountCode = cartMedicineWebBanner?.discountCode;
                newState.textPlaceOrderCTA = cartMedicineWebBanner?.textPlaceOrderCTA;
                newState.features = cartMedicineWebBanner?.features;
                newState.text = 'Why choose Pharmeasy for medicines?';
                newState.bannerType = cartMedicineWebBanner?.bannerType;
                newState.bgImage = cartMedicineImg;
                newState.phoneContact = cartMedicineWebBanner?.phoneContact;
                newState.whatsAppContact = cartMedicineWebBanner?.whatsAppContact;
            }
                break;
            case isDiagnosticPresentNOrdering: {
                newState.title = cartLabWebBanner?.title;
                newState.subTitle = cartLabWebBanner?.subTitle;
                newState.discountCode = cartLabWebBanner?.discountCode;
                newState.textPlaceOrderCTA = cartLabWebBanner?.textPlaceOrderCTA;
                newState.features = cartLabWebBanner?.features;
                newState.text = 'Why choose Pharmeasy for lab test?';
                newState.bannerType = cartLabWebBanner?.bannerType;
                newState.bgImage = cartLabImg;
                newState.phoneContact = cartLabWebBanner?.phoneContact;
                newState.whatsAppContact = cartMedicineWebBanner?.whatsAppContact;
            } break;
        }
        const labState = { ...cartLabWebBanner, bgImage: cartLabImg, isComboCard, isMedicinePresentNOrdering, isDiagnosticPresentNOrdering };
        const medState = { ...cartMedicineWebBanner, bgImage: cartMedicineImg, isComboCard, isMedicinePresentNOrdering, isDiagnosticPresentNOrdering };
        setState({
            ...newState, labState, medState, showOfferCard, isComboCard, isMedicinePresentNOrdering, isDiagnosticPresentNOrdering,
        });
    }

    function handleTabChange(value) {
        setSelectedTab(value);
        setTabChange(true);
    }

    function handleInputChange({ value = '' }: any) {
        setSearchInput(value);
        setPincodeUpdated(true);
        if (searchInput.length === 5) {
            setMaxSearchInput(true);
        }
    }

    function goBack() {
        history.back();
    }

    function clearSearchInput() {
        setPincodeUpdated(true);
        setSearchInput('');
        setMaxSearchInput(false);
    }

    function renderCurrentTabContent() {
        switch (selectedTab) {
            case 'LAB TESTS':
                return (
                    <>
                        <Card>
                            <LabCart
                                visitID={visitID}
                                patientID={patientID}
                                doctorID={doctorID}
                                searchInput={searchInput}
                                pincodeUpdated={pincodeUpdated}
                                state={state.labState}
                                cartItems={cartItems}
                                pincodeChanged={pincodeChanged}
                                tabChange={tabChange}
                            />
                        </Card>
                        <TextCenter title={state.text} />
                        <InfoItems>
                            {
                                cartLabWebBanner?.features?.map((feature, index) => (
                                    <CardBox key={index}>
                                        <Image
                                            ignoreAssetsPath
                                            src={feature.iconUrl} />
                                        {feature.text}
                                    </CardBox>
                                ))
                            }
                        </InfoItems>
                    </>
                );

            case 'MEDICINES':
                return (
                    <>
                        <Card>
                            <MedicineCart
                                visitID={visitID}
                                patientID={patientID}
                                doctorID={doctorID}
                                searchInput={searchInput}
                                pincodeUpdated={pincodeUpdated}
                                state={state.medState}
                                cartItems={cartItems}
                                pincodeChanged={pincodeChanged}
                                tabChange={tabChange}
                            />
                        </Card>
                        <TextCenter title={state.text} />
                        <InfoItems>
                            {
                                cartMedicineWebBanner?.features?.map((feature, index) => (
                                    <CardBox key={index}>
                                        <Image
                                            ignoreAssetsPath
                                            src={feature.iconUrl} />
                                        {feature.text}
                                    </CardBox>
                                ))
                            }
                        </InfoItems>
                    </>
                );
            default:
                return null;
        }
    }

    if (showError)
        return (
            <Layout>
                <Card>
                    <Heading4 title={'VisitID does not belong to the user'} />
                </Card>
            </Layout>
        );

    if (!state.showOfferCard) return null;

    if (bannerByType === {} || isEmpty(feature) || pincodeReceived) return (<Loader />);

    if (state.isComboCard)
        return (
            <Layout>
                <Card>
                    <SearchBox>
                        <DoconInput
                            name='search'
                            value={searchInput}
                            rootClassName='templateSearchInputClass'
                            placeholder='Enter Pincode'
                            prefix={<Icons.LocationIcon color={`${colors.primaryBlue}`} /> as any}
                            onChange={handleInputChange}
                            disabled={maxSearchInput}
                            suffix={<Icons.PencilIcon color={`${colors.primaryBlue}`} onClick={clearSearchInput} /> as any}
                        />
                        <CrossIcon onClick={goBack} />
                    </SearchBox>
                    {
                        searchInput.length === 6 ?
                            !isEmpty(cartItems) ?
                                <>
                                    <BaseBox>
                                        <Heading3 title={'Your cart is ready!'} />
                                        <Heading4
                                            title={`Items added to cart prescribed by, Dr. ${cartItems?.['doctor']?.['firstName']} ${cartItems?.['doctor']?.['lastName']} on ${moment(new Date(cartItems?.['visitIDCreationDate'])).format('DD MMM, YYYY')}`}
                                            color={`${colors.secondaryColor}`}
                                        />
                                    </BaseBox>
                                    <DoconTabs
                                        tabWidth={''}
                                        verticalSpace={0}
                                        vertical={false}
                                        tabs={Tabs}
                                        selectedTab={selectedTab}
                                        onTabChange={handleTabChange}
                                        currentTabContent={null}
                                    />
                                    {renderCurrentTabContent()}
                                </>
                                : <Loader /> : null
                    }
                </Card>
            </Layout>);

    return (
        <Layout>
            <Card>
                <SearchBox>
                    <DoconInput
                        name='search'
                        value={searchInput}
                        rootClassName='templateSearchInputClass'
                        placeholder='Enter Pincode'
                        prefix={<Icons.LocationIcon color={`${colors.primaryBlue}`} /> as any}
                        onChange={handleInputChange}
                        disabled={maxSearchInput}
                        suffix={<Icons.PencilIcon color={`${colors.primaryBlue}`} onClick={clearSearchInput} /> as any}
                    />
                    <CrossIcon onClick={goBack} />
                </SearchBox>
                {
                    searchInput.length === 6 ?
                        !isEmpty(cartItems) ?
                            <>
                                <BaseBox>
                                    <Heading3 title={'Your cart is ready!'} />
                                    <Heading4 title={`Items added to cart prescribed by, Dr. ${cartItems?.['doctor']?.['firstName']} ${cartItems?.['doctor']?.['lastName']} on ${moment(new Date(cartItems?.['visitIDCreationDate'])).format('DD MMM, YYYY')}`}
                                        color={`${colors.secondaryColor}`}
                                    />
                                </BaseBox>
                                <Card>
                                    {
                                        state.bannerType === 'cartLabWebBanner' ?
                                            <LabCart
                                                visitID={visitID}
                                                patientID={patientID}
                                                doctorID={doctorID}
                                                searchInput={searchInput}
                                                pincodeUpdated={pincodeUpdated}
                                                state={state}
                                                diagnosticsCount={diagnosticsCount}
                                                medicinesCount={medicinesCount}
                                                cartItems={cartItems}
                                                pincodeChanged={pincodeChanged}
                                                tabChange={tabChange}
                                            />
                                            :
                                            <MedicineCart
                                                visitID={visitID}
                                                patientID={patientID}
                                                doctorID={doctorID}
                                                searchInput={searchInput}
                                                pincodeUpdated={pincodeUpdated}
                                                state={state}
                                                diagnosticsCount={diagnosticsCount}
                                                medicinesCount={medicinesCount}
                                                cartItems={cartItems}
                                                pincodeChanged={pincodeChanged}
                                                tabChange={tabChange}
                                            />
                                    }
                                </Card>
                                <TextCenter title={state.text} />
                                <InfoItems>
                                    {
                                        state?.features?.map((feature, index) => (
                                            <CardBox key={index}>
                                                <Image
                                                    ignoreAssetsPath
                                                    src={feature.iconUrl}
                                                />
                                                {feature.text}
                                            </CardBox>
                                        ))
                                    }
                                </InfoItems>
                            </>
                            : <Loader /> : null
                }
            </Card>
        </Layout>
    );
}

export default CartComponent;